const regions = [
  {
    icon: "ri-map-pin-2-line",
    region: "Nairobi, Kenya",
    desc: "Our primary East African operating base and the financial, innovation, and entrepreneurship hub at the center of Harambee Global Ventures.",
    highlight: true,
  },
  {
    icon: "ri-building-line",
    region: "Fort Lauderdale, Florida",
    desc: "A stated primary market in the business plan, strengthening Harambee's North American diaspora connection and cross-border relationship network.",
    highlight: false,
  },
  {
    icon: "ri-global-line",
    region: "East Africa",
    desc: "We are deeply connected to the East African business and investment landscape, with a focus on long-term opportunity development across the region.",
    highlight: false,
  },
  {
    icon: "ri-flight-takeoff-line",
    region: "North America",
    desc: "Serving African Diaspora professionals, families, and investors across the United States and Canada with cross-border education and advisory support.",
    highlight: false,
  },
  {
    icon: "ri-earth-line",
    region: "Europe & UK",
    desc: "Engaging with the African Diaspora community across the United Kingdom and Europe, supporting financial education and cross-border opportunity access.",
    highlight: false,
  },
];

export default function LocationReach() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
              <span className="w-8 h-px bg-[#C9A961]" />
              Our Reach
            </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
              Nairobi to Fort Lauderdale.<br />
              <span className="text-[#1A4D3C]">Globally Connected.</span>
            </h2>
            <p className="text-[#6B6B6B] text-base leading-relaxed mb-10">
              Harambee Global Ventures is anchored in Nairobi, Kenya and identifies Fort Lauderdale, Florida among its primary markets. From this cross-border foundation, we engage the African Diaspora and strategic partners across East Africa, North America, Europe, and beyond.
            </p>

            <div className="space-y-4">
              {regions.map((r) => (
                <div
                  key={r.region}
                  className={`flex items-start gap-4 p-5 rounded-lg border transition-colors ${
                    r.highlight
                      ? "bg-[#1A4D3C] border-[#1A4D3C]"
                      : "bg-white border-[#E8E4DC] hover:border-[#C9A961]/40"
                  }`}
                >
                  <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 ${r.highlight ? "bg-white/15" : "bg-[#1A4D3C]/10"}`}>
                    <i className={`${r.icon} text-base ${r.highlight ? "text-[#C9A961]" : "text-[#1A4D3C]"}`} />
                  </div>
                  <div>
                    <div className={`font-semibold text-sm mb-1 ${r.highlight ? "text-white" : "text-[#2B2D2F]"}`}>
                      {r.region}
                    </div>
                    <div className={`text-xs leading-relaxed ${r.highlight ? "text-white/70" : "text-[#6B6B6B]"}`}>
                      {r.desc}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="/assets/images/site/location-reach-001-640x560.jpg"
              alt="Nairobi Kenya Harambee Global Ventures headquarters"
              className="w-full h-[480px] object-cover object-top rounded-lg"
            />
            <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm rounded-lg p-4 border border-[#E8E4DC]">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1A4D3C]/10">
                  <i className="ri-map-pin-2-line text-[#1A4D3C] text-sm" />
                </div>
                <div>
                  <div className="font-semibold text-[#2B2D2F] text-xs">Headquarters</div>
                  <div className="text-[#6B6B6B] text-xs">Nairobi, Kenya</div>
                </div>
              </div>
            </div>
            <div className="absolute bottom-6 right-6 bg-[#1A4D3C] rounded-lg p-4">
              <div className="text-[#C9A961] font-['Cormorant_Garamond'] text-2xl font-bold">5+</div>
              <div className="text-white/70 text-xs">Global Regions</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
